// @flow
import * as React from 'react'
import { Container, Item } from './elements'

// Types
type WrapTypes = 'xs' | 'sm' | 'md' | 'lg' | 'inf' | 'auto'
type Props = {
  CellComponent?: any,
  children?: any,
  wrap?: WrapTypes,
  cols?: number,
  color?: string,
  flexible?: boolean,
  verticalGutter?: boolean,
  horizontalGutter?: boolean,
  innerBorder?: string,
  edgeGutter?: boolean,
}
type FieldProps = {
  children?: any,
  col?: number,
  valign?: string,
  as?: any,
  CellComponent?: any,
  wrap?: WrapTypes,
  cols?: number,
  index?: number,
  length?: number,
  flexible?: boolean,
  verticalGutter?: boolean,
  horizontalGutter?: boolean,
  innerBorder?: string,
  edgeGutter?: boolean,
}

/**
 * A field wrapper that provides a way to set different
 * field apperance behaviour
 * @return {Element}
 */
export const Cell = (props: FieldProps) => {
  const {
    children,
    valign,
    col,
    wrap,
    CellComponent,
    cols,
    index,
    length,
    flexible,
    verticalGutter,
    horizontalGutter,
    innerBorder,
    edgeGutter,
  } = props

  return (
    <Item
      $as={props.as || CellComponent}
      $col={col}
      $cols={cols}
      $valign={valign}
      $wrap={wrap}
      $length={length}
      $index={index}
      $flexible={flexible}
      $verticalGutter={verticalGutter}
      $horizontalGutter={horizontalGutter}
      $innerBorder={innerBorder}
      $edgeGutter={edgeGutter}
    >
      {children}
    </Item>
  )
}
Cell.defaultProps = {
  valign: 'normal',
  CellComponent: 'div',
  col: 1,
  cols: 12,
  index: 0,
  length: 0,
}

/**
 * A component for showing a row of form fields with
 * a little space between fields in a row and wrapping
 * fields on mobile devices
 * @return {Element}
 */
export const Row = (props: Props) => {
  const {
    CellComponent,
    children,
    wrap,
    color,
    flexible,
    verticalGutter,
    horizontalGutter,
    innerBorder,
    edgeGutter,
    cols: rawCols,
  } = props
  const childrenArray = React.Children.toArray(children).filter(
    (child) => !!child
  )

  const { length } = childrenArray
  const cols = typeof rawCols !== 'undefined' ? rawCols : length

  return (
    <Container
      $wrap={wrap}
      $color={color}
      $edgeGutter={edgeGutter}
      $verticalGutter={verticalGutter}
      $horizontalGutter={horizontalGutter}
    >
      {childrenArray.map((child, index) => {
        const cellProps = {
          key: index,
          innerBorder,
          horizontalGutter,
          verticalGutter,
          edgeGutter,
          flexible,
          index,
          length,
          cols,
          wrap,
          CellComponent,
        }
        if (child.type === Cell) {
          return React.cloneElement(child, cellProps)
        }
        return (
          <Cell key={index} {...cellProps}>
            {child}
          </Cell>
        )
      })}
    </Container>
  )
}
Row.defaultProps = {
  color: 'transparent',
  horizontalGutter: true,
  verticalGutter: false,
}

export default Row
